/** Return direct next/head children: custom components inside Head are not collected by Next. */
export const medleveIconLinks = () => [
  <link key="medleve-ico" rel="icon" href="/favicon.ico" sizes="32x32" />,
  <link key="medleve-svg" rel="icon" href="/icon.svg" type="image/svg+xml" />,
  <link key="medleve-apple-icon" rel="apple-touch-icon" href="/apple-touch-icon.png" />,
  <link key="medleve-manifest" rel="manifest" href="/site.webmanifest" />
]
